import React, { useState, useEffect, Component } from 'react';
import { Link, useParams} from 'react-router-dom';
import consultant from "../../images/banner/consultant.png";
import addnew from "../../images/icon/addnew.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';

function Requirements(){

    const [records, setRecords] = useState([]);
    let id = window.location.href.split('/')[5]
    useEffect(() => {
        axios.get(`https://api.transnational.ai/api/requirements/${id}`) 
            .then(response => {
                console.log(response.data)
                setRecords(response.data.requirements);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []); 

    const servicesStyle = {
        backgroundImage: `url(${consultant})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor :'#e6f4ff',
        width :'100%',
        height: '33vh',
    };

    return (
        <section style={{ background :'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="container" style={{ background :'#ffffff' }}>
                <div className="col-12" style={{ margin:'0 auto'}}>
                    <div className="well well-small" style={{ textAlign:"left" }}>
                        <ul className="media-list">
                            <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                    <div  className="col-md-12 breadcrumbs" >
                                        <a href="/executive/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/executive/Clients">Clients</a> <i class="bi bi-chevron-double-right"></i> <span>Requirements</span>
                                    </div>
                                </section>
                                <div className="media-body" style={{ minHeight : '500px' , padding : '40px'}}>
                                    <h3 className="media-heading"></h3>
                                    <table className="mytable">
                                    <thead>
                                        <tr>
                                        <th>Requirement</th>
                                        <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {records.map(item => (
                                        <tr  key={item.id}>
                                        <td><Link  to={`/executive/Candidates/${item.rqid}`}>{item.requirement}</Link></td>
                                        <td><Link  to={`/executive/Addcandidate/${item.rqid}`}><img src={addnew} /></Link></td>
                                        </tr>
                                    ))} 
                                    </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default Requirements